/* eslint-disable complexity */

const isProdTenantLinkedToTestExp = () => {
    // IF ANOTHER CLIENT COMES ON WHO WANTS TO LINK THEIR PROD TENANT TO THE TEST EXP, ADD THEM HERE
    // if (window.location.host.includes('ecb.test')) {
    //     return true;
    // }

    return false;
};

export const getClientHost = () => {
    return `${window.PLAYBOOK_CONFIG.tenant}${
        isProdTenantLinkedToTestExp() ? '' : process.env.ENV_SUBDOMAIN
    }${process.env.ENV_BASE_DOMAIN}`;
};

export const determineTenant = (embedTenant = false) => {
    if (window.PLAYBOOK_CONFIG?.tenant) {
        return;
    }

    if (!window.PLAYBOOK_CONFIG) {
        window.PLAYBOOK_CONFIG = {};
    }

    if (window.location.host.includes('localhost:9001')) {
        window.PLAYBOOK_CONFIG.tenant = 'pulselive-dev';
        return;
    }

    // special case for wta while they update embed codes
    // Remove as part of migraton to aid dev testing
    // if (window.location.host.includes('wta')) {
    //     window.PLAYBOOK_CONFIG.tenant = 'wta';
    //     return;
    // }

    if (embedTenant) {
        window.PLAYBOOK_CONFIG.tenant = embedTenant;
        return;
    }

    if (
        window.location.host.includes('widget-showcase') ||
        window.location.host.includes('web2.demo.pulselive') ||
        window.location.host.includes('web1.demo.pulselive')
    ) {
        window.PLAYBOOK_CONFIG.tenant = 'pulselive-prod';
        return;
    }
};

// Used for automated experiences to determine if we should use tennis adaptor or SDP adaptor
export const isTennisAdaptor = () => {
    if (
        window.location.host.includes('tennistv') ||
        window.location.host.includes('ttv') ||
        window.location.host.includes('wta')
    ) {
        return true;
    }

    return false;
};
